import React from 'react';

import PropTypes from 'prop-types';

import DateRangePicker from 'rsuite/DateRangePicker';
import plLocale from 'date-fns/locale/pl';
import enLocale from 'date-fns/locale/en-US';
import moment from 'moment-timezone';
import UserSessionDataHandler from 'auth/UserSessionsDataHandler';

moment.tz.setDefault('UTC');

const LocaleMap = {
  pl: plLocale,
  en: enLocale,
};

const AddTemporaryActivationModal = props => {
  const { start, stop, setStart, setStop, addActivation } = props;

  const { beforeToday } = DateRangePicker;

  const userSettingObject = UserSessionDataHandler.getUserSettingsObject();
  const lang = userSettingObject[UserSessionDataHandler.defaultLanguage];
  const [dateValue, setDateValue] = React.useState([null, null]);

  const handleChangeDateTime = value => {
    if (value !== null) {
      setStart(new Date(value[0].toUTCString()).getTime());
      setStop(new Date(value[1].toUTCString()).getTime());
      setDateValue([value[0], value[1]]);
      addActivation('temporary');
    }
  };

  React.useEffect(() => {
    if (start === 0 && stop === 0) setDateValue([null, null]);
  }, [start, stop]);

  return (
    <DateRangePicker
      locale={LocaleMap[lang]}
      format="yyyy-MM-dd HH:mm:ss"
      onChange={handleChangeDateTime}
      disabledDate={beforeToday()}
      cleanable={false}
      value={dateValue}
    />
  );
};

AddTemporaryActivationModal.propTypes = {
  start: PropTypes.oneOfType([
    PropTypes.oneOf([PropTypes.instanceOf(null)]).isRequired,
    PropTypes.instanceOf(Date).isRequired,
  ]),
  stop: PropTypes.oneOfType([
    PropTypes.oneOf([PropTypes.instanceOf(null)]).isRequired,
    PropTypes.instanceOf(Date).isRequired,
  ]),
  setStart: PropTypes.func.isRequired,
  setStop: PropTypes.func.isRequired,
  addActivation: PropTypes.func.isRequired,
};

export default AddTemporaryActivationModal;
